<template>
    <nav class="page-pagination pagination-container" aria-label="Page navigation" v-if="totalPages > 1">

        <ul class="pagination justify-content-center mb-0">

            <!-- previous -->
            <li :class="{'page-item': true, 'disabled': isFirst }">
                <a class="page-link" href="#" tabindex="-1" :aria-disabled="isFirst ? 'true' : undefined" @click.prevent="click(prevPage)">
                    <i class="fa-light fa-chevron-left"></i>
                </a>
            </li>

            <!-- pages -->
            <li v-for="(page, index) in pages" :class="{'page-item': true, 'disabled': isCurrent(page)}"
                :aria-current="isCurrent(page) ? 'page' : undefined">
                <a class="page-link" href="#" @click.prevent="click(page)" v-if="page != ellipsis">
                    {{page}}
                    <span v-if="isCurrent(page)" class="sr-only">(current)</span>
                </a>
                <span v-else class="ellipsis">...</span>
            </li>

            <!-- next -->
            <li :class="{'page-item': true, 'disabled': isLast }">
                <a class="page-link" href="#" :aria-disabled="isLast ? 'true' : undefined" @click.prevent="click(nextPage)">
                    <i class="fa-light fa-chevron-right"></i>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
	emits: ['change'],

    props: {
        'data': {
            type: Object,
            default: () => {
                return {}
            }
        },

        'delta': {
            type: Number,
            default: 2
		},

		'viewAll': {
            type: String,
            default: ''
        }
    },

    beforeUpdate() {
        this.pages = this.generatePageRange();
    },

    mounted() {
        this.pages = this.generatePageRange();
    },

    data() {
        return {
            ellipsis: '...',
            pages: []
        }
    },

    methods: {
        // generate a range of pages numbers around the current page
        generatePageRange() {
            var currentPage = this.currentPage;
            var lastPage = this.totalPages;
            var delta = this.delta;
            var ellipsis = this.ellipsis;

            // creates array with base 1 index
            const range = Array(lastPage)
                .fill()
                .map((_, index) => index + 1);

            return range.reduce((pages, page) => {
                // allow adding of first and last pages
                if (page === 1 || page === lastPage) {
                    return [...pages, page];
                }

                // if within delta range add page
                if (page - delta <= currentPage && page + delta >= currentPage) {
                    return [...pages, page];
                }

                // otherwise add 'gap if gap was not the last item added.
                if (pages[pages.length - 1] !== ellipsis) {
                    return [...pages, ellipsis];
                }

                return pages;
            }, []);
        },

        // is N the current page?
        isCurrent(n) {
            return this.currentPage == n;
        },

        // handle click on page link
        click(n) {
            if( n < 1) n == 1;
            else if( n > this.totalPages) n = this.totalPages;
            
            if( n != this.currentPage) {
                this.$emit('change', n);

                const element = document.getElementById('app');

                if (element) {
                    element.scrollIntoView({
                        behavior: 'instant', 
                        block: 'start',
                        inline: 'start'
                    });
                }
            }
        },
    },

    computed : {

        // is current the first page?
        isFirst() {
            return this.currentPage == 1;
        },

        // is current the last page?
        isLast() {
            return this.currentPage == this.totalPages;
        },

        // next page number
        nextPage() {
            return Math.min(this.totalPages, this.currentPage + 1);
        },

        // previous page number
        prevPage() {
            return Math.max(1, this.currentPage - 1);
        },

        // what is the current page?
        currentPage() {
            return this.data.currentPage
        },

        // records per page
        recordsPerPage() {
            return this.data.recordsPerPage;
        },

        // total pages
        totalPages() {
            return this.data.totalPages;
        },

        // total records
        totalRecords() {
            return this.data.totalRecords;
        },

    }
}

</script>